var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_1504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 19.2929C12.9024 19.6834 12.9024 20.3166 13.2929 20.7071C13.6835 21.0976 14.3166 21.0976 14.7072 20.7071L22 13.4142C22.7811 12.6332 22.7811 11.3668 22 10.5858L14.7072 3.29289C14.3166 2.90237 13.6835 2.90237 13.2929 3.29289C12.9024 3.68341 12.9024 4.31657 13.2929 4.7071L19.5858 11H3C2.44769 11 2 11.4477 2 12C2 12.5523 2.44769 13 3 13H19.5858L13.2929 19.2929Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_1504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.44938f031a03496eb11c31ff238f6ab2.svg";
export { ForwardRef as ReactComponent };